import type { FormInstance } from "antd"

/**
 * Form values extend FormData (a string index signature), so AntD infers
 * nested NamePath as [string, number]. These calls pass two string keys.
 * Runtime AntD accepts that path; this is the single assertion for it.
 */
export const setNestedFormField = (
  form: FormInstance,
  name: readonly [string, string],
  value: string | number | boolean
): void => {
  const setFieldValue = form.setFieldValue as (
    path: readonly [string, string],
    next: string | number | boolean
  ) => void
  setFieldValue(name, value)
}
